import React from "react";
import "./UserPanel.scss";

// import Avatar from "components/Avatar";
import Button from "components/Button";
// import Notifications from "./Notifications";
// import Messages from "./Messages";

import { withFirebase } from "components/Firebase";

const SignOutComponent = ({ firebase }) => (
  <Button onClick={firebase.doSignOut} type="primary">
    Sign out
  </Button>
);

const SignOutButton = withFirebase(SignOutComponent);

const UserPanel = ({ user }) => (
  <div className="UserPanel">
    {/* <Notifications count={0} /> */}
    {/* <Messages count={4} /> */}
    {/* <Avatar size={48} image="http://i.pravatar.cc/256" /> */}
    <Button type="primary" to={`/u/${user && user.userName}`}>
      Profile
    </Button>
    {/* <Button type="primary" to={`/create-project`}>
      Create Project
    </Button> */}
    <SignOutButton />
  </div>
);

export default UserPanel;
